import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useRemoteReviews from "../../../../hooks/queryResults/remote/useRemoteReviews";
import Table from "../../../layout/Table";
import Loading from "../../../ui/Loading";

export default function AdminRemoteReviewsTable() {
  const { reviews: nflPlayersReviews, finalDocType: nflPlayersFinalDocType } =
    useRemoteReviews("NflPlayer");

  const reviewObjs = useMemo(() => {
    return [
      {
        type: nflPlayersFinalDocType,
        reviews: nflPlayersReviews,
      },
    ];
  }, [nflPlayersReviews, nflPlayersFinalDocType]);

  const loaded = reviewObjs.every((reviewObj) => !!reviewObj.reviews);

  const columns = useMemo(
    () => [
      { Header: "Type", accessor: "finalDocType" },
      { Header: "Num", accessor: "num" },
      { Header: "All", accessor: "all" },
      { Header: "Search", accessor: "search" },
    ],
    []
  );

  const data = useMemo(() => {
    if (!loaded) return [];
    return reviewObjs.map((reviewObj) => {
      return {
        finalDocType: (
          <Link to={`/admin/remote/reviews/${reviewObj.type}`}>
            {reviewObj.type}
          </Link>
        ),
        num: reviewObj.reviews.length,
        all: <Link to={`/admin/remote/all/${reviewObj.type}`}>All</Link>,
        search: (
          <Link to={`/admin/remote/search/${reviewObj.type}`}>Search</Link>
        ),
      };
    });
  }, [reviewObjs, loaded]);

  if (!loaded) return <Loading />;

  return <Table columns={columns} data={data} />;
}
